/* src/app/class/presenter/class-presenter.component.scss */
body#themeTag :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
  padding-top: 0.4rem !important;
  padding-bottom: 0.4rem !important;
}
body#themeTag :host ::ng-deep .button-bar {
  padding: 0;
  margin-top: -0.35em;
  padding-bottom: 0.5em;
}
/*# sourceMappingURL=class-presenter.component.css.map */
